import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { ErrorComponent } from 'error-ui';
import { ProductComponentBase } from '../../../ProductComponentBase';
import { ProductLinksViewComponent } from './views';

@Component({
  selector: 'ideal-product-links',
  imports: [ProductLinksViewComponent, ErrorComponent],
  standalone: true,
  templateUrl: './product-links.component.html',
  styleUrls: ['./product-links.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductLinksComponent extends ProductComponentBase {
  protected readonly links = this.productStore.productLinks;
  protected readonly linkItems = computed(() => this.productStore.productLinks()?.links ?? []);

  protected override computeIsLoading = () => this.links.loading;
  protected override computeHasContent = () => computed(() => !!this.links.error() || this.linkItems().length > 0);
}
